import React, { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { Link } from "react-router-dom";
import { notifyConsentChange } from "../lib/analytics";

const STORAGE_KEY = "mc_cookie_consent_v1";

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const choice = localStorage.getItem(STORAGE_KEY);
        if (!choice) {
            const t = setTimeout(() => setVisible(true), 800);
            return () => clearTimeout(t);
        }
    }, []);

    const persist = (value) => {
        const payload = { ...value, ts: new Date().toISOString() };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
        setVisible(false);
        notifyConsentChange();
    };

    if (!visible) return null;

    return (
        <div
            data-testid="cookie-banner"
            className="fixed inset-x-0 bottom-0 z-[60] animate-fade-up"
        >
            <div className="max-w-5xl mx-auto m-4 lg:m-6">
                <div className="bg-navy text-white shadow-2xl border border-gold/30">
                    <div className="absolute -top-px left-0 w-24 h-[2px] bg-gold" />
                    <div className="p-6 lg:p-8 grid grid-cols-1 lg:grid-cols-12 gap-6 items-center">
                        <div className="lg:col-span-7 flex gap-4">
                            <div className="w-10 h-10 border border-gold flex items-center justify-center flex-shrink-0">
                                <Cookie size={20} className="text-gold" />
                            </div>
                            <div>
                                <h3 className="font-serif text-xl text-gold mb-2">Cookie e Privacy</h3>
                                <p className="text-slate-200 text-sm leading-relaxed">
                                    Questo sito utilizza esclusivamente <strong>cookie tecnici</strong> necessari al suo funzionamento. Non vengono utilizzati cookie di profilazione o di marketing. Maggiori informazioni nella{" "}
                                    <Link to="/privacy" className="text-gold underline hover:no-underline" data-testid="cookie-banner-privacy-link">
                                        informativa privacy
                                    </Link>.
                                </p>
                            </div>
                        </div>
                        <div className="lg:col-span-5 flex flex-col sm:flex-row gap-3 lg:justify-end">
                            <button
                                onClick={() => persist({ technical: true, analytics: false, marketing: false, choice: "reject" })}
                                data-testid="cookie-reject"
                                className="px-5 py-3 border border-white/30 text-white text-xs uppercase tracking-[0.2em] font-semibold hover:border-gold hover:text-gold transition-colors"
                            >
                                Solo tecnici
                            </button>
                            <button
                                onClick={() => persist({ technical: true, analytics: true, marketing: false, choice: "accept" })}
                                data-testid="cookie-accept"
                                className="btn-gold !py-3"
                            >
                                Accetta
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
